import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
 
@Injectable()
export class CustomMsalInterceptor implements HttpInterceptor {
  constructor(private readonly msalService: MsalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interception for auth endpoints
    if (req.url.includes('/api/v1/auth/')) {
      // Still need to include credentials for Cloudflare cookie handling
      const authReq = req.clone({ withCredentials: true });
      return next.handle(authReq);
    }

    // Check if we have an internal auth token
    const internalToken = localStorage.getItem('accessToken');
    const tokenType = localStorage.getItem('tokenType') || 'Bearer';
   
    // Check if this is a backend API request (either relative or absolute URL)
    const isBackendApiRequest = req.url.startsWith('/api/') ||
                                req.url.includes(environment.apiBaseUrl || '') ||
                                req.url.includes(environment.apiUrl || '');
   
    // If we have an internal auth token and this is our API, use it
    if (internalToken && isBackendApiRequest) {
      console.log('Using internal auth token for:', req.url);
      const headers: any = {
        Authorization: `${tokenType} ${internalToken}`
      };
     
      // Add cache-busting headers for GET requests to prevent browser caching
      if (req.method === 'GET') {
        headers['Cache-Control'] = 'no-cache';
        headers['Pragma'] = 'no-cache';
      }
     
      // Include withCredentials for cross-origin cookie handling (required for Cloudflare)
      const authReq = req.clone({ setHeaders: headers, withCredentials: true });
      return next.handle(authReq);
    }

    // Check if user is authenticated via Azure AD
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      console.warn('⚠️ Using Azure AD token for:', req.url);
      // Get token from MSAL
      return from(
        this.msalService.acquireTokenSilent({
          scopes: ['user.read'],
          account: accounts[0]
        })
      ).pipe(
        switchMap((tokenResponse) => {
          const headers: any = {
            Authorization: `Bearer ${tokenResponse.accessToken}`
          };
         
          // Add cache-busting headers for GET requests to prevent browser caching
          if (req.method === 'GET') {
            headers['Cache-Control'] = 'no-cache';
            headers['Pragma'] = 'no-cache';
          }
         
          // Include withCredentials for cross-origin cookie handling (required for Cloudflare)
          const authReq = req.clone({ setHeaders: headers, withCredentials: true });
          return next.handle(authReq);
        })
      );
    }

    // No authentication available, proceed with credentials for Cloudflare cookie handling
    console.warn('❌ No auth token available for:', req.url);
    const credReq = req.clone({ withCredentials: true });
    return next.handle(credReq);
  }
}